import { Link, useParams, useNavigate } from 'react-router-dom';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';
//import apiMethod from '../../../services/api-service';
import Preloading from '../../../components/basics/Preloading';
import back from "../../../assets/images/icons/arrow-right2.svg";

const ReportHome = () => {
    const { branchId } = useParams();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {

    }, []);


    const moduleRender = () => {
        return (
            <>
                {loading && <Preloading></Preloading>}
                {
                    <>
                        <div className='d-none d-lg-block'>
                            <Link to={`/sale/${branchId}`} className='text-start mb-3 link back-link'>
                                <span><img src={back} className="" alt="return" /></span>
                                بازگشت
                            </Link>
                        </div>
                        <div className="salemain">
                            <div className='d-none d-lg-block'>
                                <div className='detaileheader'>
                                    <div className='d-flex align-items-baseline '>
                                        <div className='d-flex d-lg-none justify-content-start align-items-baseline '>
                                            <Link to="/dashboard" className='link back-link me-1'>
                                                <span><img src={back} className="" alt="return" /></span>
                                            </Link>
                                        </div>
                                        <p className='branchname'>گزارشات</p>
                                    </div>
                                    <p className="date d-block d-lg-none">{methods.currentDate()}</p>
                                </div>
                            </div>
                            <div>
                                <div className="row row-cols-1 row-cols-lg-3 g-4">
                                    <div className="col">
                                        <div className="card branchcardtabs">
                                            <div className='display-3 text-center pt-4'><i className="bi bi-bag"></i></div>
                                            <div className="card-body">
                                                <Link to={`/sale/${branchId}/reports/product`}>
                                                    <button type="submit" className="btn custome-btn btn-link-purple w-100" data-toggle="hover-effect">
                                                        گزارش اقلام کالا
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="card branchcardtabs">
                                            <div className='display-3 text-center pt-4'><i className="bi bi-receipt"></i></div>
                                            <div className="card-body">
                                                <Link to={`/sale/${branchId}/reports/invoice`}>
                                                    <button type="submit" className="btn custome-btn btn-link-purple w-100" data-toggle="hover-effect">
                                                        گزارش به تفکیک فاکتور
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="card branchcardtabs" >
                                            <div className='display-3 text-center pt-4'><i className="bi bi-person-lines-fill"></i></div>
                                            <div className="card-body">
                                                <Link to={`/sale/${branchId}/reports/merchant`}>
                                                    <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                                        گزارش فروش براساس مشتری
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="card branchcardtabs" >
                                            <div className='display-3 text-center pt-4'><i className="bi bi-bar-chart-steps"></i></div>
                                            <div className="card-body">
                                                <Link to={`/sale/${branchId}/reports/sales`}>
                                                    <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                                        گزارش کلی فروش
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="card branchcardtabs" >
                                            <div className='display-3 text-center pt-4'><i className="bi bi-receipt"></i></div>
                                            <div className="card-body">
                                                <Link to={`/sale/${branchId}/reports/invoiceItem`}>
                                                    <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                                        گزارش فروش براساس اقلام فاکتور
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="card branchcardtabs" >
                                            <div className='display-3 text-center pt-4'><i className="bi bi-receipt"></i></div>
                                            <div className="card-body">
                                                <Link to={`/sale/${branchId}/reports/cancellOrderSnapp`}>
                                                    <button type="submit" className="btn custome-btn btn-link-purple w-100">
                                                        گزارش داده های فروش اسنپ
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </>
        )
    };

    return (
        <>
            {moduleRender()}
        </>
    );
}

export default ReportHome;